module.exports = __webpack_public_path__ + "media/hyper/images/payments/payoneer-7aed714391c580c4049d3f942ebd067e.png";